import React from 'react';
import { AttachMediaModal } from '../../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../../components/ElementWrapper';
import { IElement } from '../../../../models/Element';
import { HomeImageLeftDescriptionContent } from './HomeImageLeftDescriptionContent';
import { HomeImageLeftDescriptionElement } from './HomeImageLeftDescriptionElement';
import { HomeImageLeftDescriptionFigure } from './HomeImageLeftDescriptionFigure';

interface HomeImageLeftDescriptionProps {
  index: number;
  data: HomeImageLeftDescriptionElement;
  updateData: (element: IElement, index: number) => void;
}

export const HomeImageLeftDescriptionFC: React.FC<
  HomeImageLeftDescriptionProps
> = ({ index, data, updateData }) => {
  const update = (fieldsToUpdate: Partial<HomeImageLeftDescriptionElement>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-image-left-description">
          <div className="position-relative align-items-center showcase">
            <HomeImageLeftDescriptionContent data={data} update={update} />
            <HomeImageLeftDescriptionFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
